import React, { useState, useEffect } from "react";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import Login from "./pages/Login";
import Dashboard from "./pages/Dashboard";
import MainDashboard from "./pages/MainDashboard";
import HeatMapDashboard from "./pages/HeatMapDashboard";
import AdminUpload from "./pages/AdminUpload";
import { verifyToken } from "./data/api";

const ProtectedRoute = ({ children, user }) => {
  if (!user) return <Navigate to="/login" replace />;
  return children;
};

export default function App() {
  const [user, setUser] = useState(null);
  const [checking, setChecking] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem('token');
    if (token) {
      verifyToken()
        .then(res => setUser(res.data.user))
        .catch(() => {
          localStorage.removeItem('token');
          localStorage.removeItem('user');
        })
        .finally(() => setChecking(false));
    } else {
      setChecking(false);
    }
  }, []);

  if (checking) {
    return (
      <div style={{
        minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center',
        background: '#0f172a', color: '#fff', fontSize: '1.1rem'
      }}>
        Loading...
      </div>
    );
  }

  return (
    <Router>
      <Routes>
        <Route path="/login" element={
          user ? <Navigate to="/heatmap" replace /> : <Login onLogin={setUser} />
        } />
        <Route path="/" element={
          <ProtectedRoute user={user}><MainDashboard /></ProtectedRoute>
        } />
        <Route path="/state_dashboard" element={
          <ProtectedRoute user={user}><Dashboard /></ProtectedRoute>
        } />
        <Route path="/heatmap" element={
          <ProtectedRoute user={user}><HeatMapDashboard /></ProtectedRoute>
        } />
        <Route path="/admin/upload" element={
          <ProtectedRoute user={user}><AdminUpload /></ProtectedRoute>
        } />
        <Route path="*" element={<Navigate to={user ? "/heatmap" : "/login"} replace />} />
      </Routes>
    </Router>
  );
}
